import { useRef } from "react";

import {
  PHONE_PLACEHOLDER,
  PHONE_PREFIX,
  formatNational,
  nationalDigits,
} from "../lib/phone";

/**
 * Pole numeru z przyklejonym prefiksem `+48`.
 *
 * Prefiks jest poza polem tekstowym, więc nie da się go skasować backspace'em —
 * wcześniej dawało się zostawić samo „22" i wysłać kod donikąd.
 */
export function PhoneInput({
  digits,
  onChange,
  onEnter,
  disabled,
  label,
  autoFocus,
}: {
  digits: string;
  onChange: (digits: string) => void;
  onEnter?: () => void;
  disabled?: boolean;
  label: string;
  autoFocus?: boolean;
}) {
  const ref = useRef<HTMLInputElement>(null);

  return (
    <div className={`phone${disabled ? " phone--disabled" : ""}`} onClick={() => ref.current?.focus()}>
      <span className="phone__prefix" aria-hidden="true">
        {PHONE_PREFIX}
      </span>
      <input
        ref={ref}
        className="phone__input"
        type="tel"
        inputMode="numeric"
        autoComplete="tel-national"
        placeholder={PHONE_PLACEHOLDER}
        aria-label={label}
        disabled={disabled}
        autoFocus={autoFocus}
        value={formatNational(digits)}
        onChange={(event) => onChange(nationalDigits(event.target.value))}
        onKeyDown={(event) => {
          if (event.key === "Enter") onEnter?.();
        }}
      />
    </div>
  );
}
